import mixpanel from 'mixpanel-browser';
import { useCallback } from 'react';

import { FilterInteractionTrackingEvents } from '@revelio/core';

import { useOptionalRevelioPageId } from '../../components/PageConfigProvider/PageConfigProvider';
import type { Filter } from '../types/filters';

/**
 * `filter reset`: the destructive clear inside a filter form. Reports how much
 * the pending selection held, never what. Removing a chip is a different
 * gesture and stays uncounted for now — `reset_scope` leaves room for it.
 */
export const useTrackFilterReset = () => {
  const pageId = useOptionalRevelioPageId();

  return useCallback(
    (
      filter: Pick<Filter, 'id' | 'type'>,
      { selectionCountBefore }: { selectionCountBefore: number }
    ) => {
      mixpanel.track(FilterInteractionTrackingEvents.FILTER_RESET, {
        filter_id: filter.id,
        filter_type: filter.type,
        page_id: pageId,
        had_selections: selectionCountBefore > 0,
        selection_count_before: selectionCountBefore,
        reset_scope: 'form',
      });
    },
    [pageId]
  );
};
